import React, { PropsWithChildren, useCallback } from 'react';

import { Label } from './styled';

interface IRadioProps {
    id?: string,
    name?: string,
    value?: string,
    checked?: boolean,
    disabled?: boolean,
    required?: boolean,
    onChange: (value: string, event?: React.ChangeEvent<HTMLInputElement>) => void,
    className?: string,
    [key: string]: unknown,
}

const MultiCheckbox = ({
    id,
    name = '',
    value = '',
    checked,
    disabled = false,
    required,
    children,
    onChange,
    className,
    ...props
}: PropsWithChildren<IRadioProps>) => {
    const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            onChange(event.target.value, event);
        }
    }, [disabled, onChange]);

    return (
        <Label
            isChecked={checked}
            disabled={disabled}
            withLabel={!!children}
            className={className}
            {...props}
        >
            <input
                type='checkbox'
                id={id}
                name={name}
                value={value}
                checked={checked}
                disabled={disabled}
                required={required}
                onChange={onChangeHandler}
            />
            <span>{children}</span>
        </Label>
    );
};

export default MultiCheckbox;
